import { DELETE_ITEM, REORDER_LIST_ITEM, SET_INTV, SET_ITEM } from '../actions'

const setNestedProp = (data, stringPath, value) => {
  var schema = data;  // a moving reference to internal objects within data
  var path = stringPath.split(',');
  var len = path.length;
  for(var i = 0; i < len-1; i++) {
      var elem = path[i];
      if ( !isNaN(path[i + 1]) && !schema[elem] ) {
        schema[elem] = []
      } else if( !schema[elem] ) {
        schema[elem] = {}
      }
      schema = schema[elem];
  }
  
  schema[path[len-1]] = value;
  
}

const deleteNestedProp = (data, stringPath) => {
  var schema = data;  // a moving reference to internal objects within data
  var path = stringPath.split(',');
  var len = path.length;
  for(var i = 0; i < len-1; i++) {
      var elem = path[i];
      if ( ( !isNaN(path[i + 1]) && !schema[elem] )|| !schema[elem])  {
        return;
      }
      schema = schema[elem];
  }
  
  if (Array.isArray(schema)) {
    schema.splice(path[len-1],1);
  } else {
    delete schema[path[len-1]];
  }
}

const reorder = (data, stringPath, startIndex, endIndex) => {
  var schema = data;  // a moving reference to internal objects within data
  var path = stringPath.split(',');
  var len = path.length;
  for(var i = 0; i < len; i++) {
    var elem = path[i];
    if ( !schema[elem] ) {
      return;
    }
    schema = schema[elem]
  }

  let arr = Array.isArray(schema) ? schema : [];

  const [removed] = arr.splice(startIndex, 1);
  arr.splice(endIndex, 0, removed);
  setNestedProp(data, stringPath, arr)
};

export default (interactive = {}, action) => {
  var newIntv;
  switch (action.type) {
    case DELETE_ITEM: 
      newIntv = {...interactive}
      deleteNestedProp(newIntv, action.payload.path);  
      return newIntv;
    case REORDER_LIST_ITEM: 
      newIntv = {...interactive}
      reorder(newIntv, action.payload.path, action.payload.start, action.payload.end);
      return newIntv;
    case SET_ITEM: 
      newIntv = {...interactive}
      if (action.payload.value === null) {
        deleteNestedProp(newIntv, action.payload.path);  
      } else {
        setNestedProp(newIntv, action.payload.path, action.payload.value);
      }
      return newIntv;
    case SET_INTV: 
      return action.payload;
    default:
      return interactive;
  }
 
}